import styled from '@emotion/styled';

export const CardNoticeContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	/* padding: 2rem 3.2rem; */
	background-color: #fff;
	border-radius: 1.6rem;
	flex: 1;
	min-height: 41rem;
`;
